const prevBtnVertical = document.getElementById("prevBtnVertical");
const nextBtnVertical = document.getElementById("nextBtnVertical");
const prevBtnHorizontal = document.getElementById("prevBtnHorizontal");
const nextBtnHorizontal = document.getElementById("nextBtnHorizontal");
const carousel = document.getElementById("carouselVertical");
const carouselH = document.getElementById("carouselHorizontal");
const mobileCarousel = window.innerWidth <= 999;
let cards;
const productContainer = document.getElementById("productContainer");

let currentIndex = 0;
let firstCardSelected = false;
let productData = {};

prevBtnVertical.addEventListener("click", () => {
  if (currentIndex > 0) {
    currentIndex--;
    updateCarousel();
  }
});

nextBtnVertical.addEventListener("click", () => {
  if (currentIndex < cards.length - 1) {
    currentIndex++;
    updateCarousel();
  }
});

prevBtnHorizontal.addEventListener("click", () => {
  if (currentIndex > 0) {
    currentIndex--;
    updateCarousel();
  }
});

nextBtnHorizontal.addEventListener("click", () => {
  if (currentIndex < cards.length - 1) {
    currentIndex++;
    updateCarousel();
  }
});

function updateCarousel() {
  if (mobileCarousel) {
    cards = document.querySelectorAll(".cardHorizontal");
    const translateX = -currentIndex * cards[0].offsetWidth;
    carouselH.style.transform = `translateX(${translateX}px)`;
  } else {
    cards = document.querySelectorAll(".card");
    const translateY = -currentIndex * cards[0].offsetHeight;
    carousel.style.transform = `translateY(${translateY}px)`;
  }
}

updateCarousel();

function handleCardClick(event) {
  const cardClickEvent = new CustomEvent("cardClick", {
    detail: {
      card: event.currentTarget,
    },
  });
  document.dispatchEvent(cardClickEvent);
}

cards.forEach((card) => {
  card.addEventListener("click", handleCardClick);
});

const _currentProductEvent = (productData) => {
  return new CustomEvent("VTOCurrentProduct", {
    detail: { productData },
  });
};

document.addEventListener("DOMContentLoaded", async function () {
  async function setUpCardClickListener() {
    return new Promise((resolve) => {
      cards.forEach((card, index) => {
        card.addEventListener("click", () => {
          // Remove the selected class from all cards
          cards.forEach((card) => card.classList.remove("selected"));
          // Adds the selected class only to the clicked card
          card.classList.add("selected");
          const productId = card.getAttribute("product-id");
          if (currentProductFrame.products) {
            let currentProduct = currentProductFrame.products.find(
              (product) => product.id === productId
            );

            productData = {
              currentProduct: currentProduct,
              loaderText: currentProductFrame.loaderText,
            };

            productContainer.innerHTML = `Luces bien con:
                    <h1 class="product-info__title h2"> ${currentProduct.title} </h1>
                    <a class="button button--xl" href="${currentProduct.url}">Ver Detalles</a>`;

            dispatchProductEvent(productData);
          }
        });

        // Select the first card automatically
        if (index === 0) {
          setTimeout(() => {
            card.click();
            dispatchProductEvent(productData);
            resolve();
          }, 0);
        }
      });
    });
  }
  await setUpCardClickListener();

  function dispatchProductEvent(productData) {
    document.dispatchEvent(_currentProductEvent(productData));
  }
});
